<template>
  <b-card title="ثبت اطلاعات بانکی و درخواست درگاه">
    <!--begin: Wizard Step 5-->
    <form @submit.prevent="handleSubmit">
      <div class="pb-5" data-wizard-type="step-content">
        <!-- <h4 class="mb-10 font-weight-bold text-dark">
        
      </h4> -->
        <b-alert :show="errorsp.length > 0" variant="danger">
          <p v-for="item of errorsp" v-bind:key="item">{{ item }}</p>
        </b-alert>

        <div class="row">
          <b-col sm="6" md="4">
            <b-form-group label="نام فروشگاه:">
              <b-form-input
                v-model="$v.step5.website_name.$model"
                :state="validateState('website_name')"
              ></b-form-input>

              <b-form-invalid-feedback
                v-if="!$v.step5.website_name.required"
                id="input-1-live-feedback"
              >
                وارد کردن نام فروشگاه اجباری است
              </b-form-invalid-feedback>
              <b-form-invalid-feedback
                v-else-if="!$v.step5.website_name.fachars"
                id="input-1-live-feedback"
              >
                نام فروشگاه باید به صورت فارسی وارد شود
              </b-form-invalid-feedback>
              <b-form-invalid-feedback
                v-else-if="!$v.step5.website_name.minLength"
                id="input-1-live-feedback"
                >نام فروشگاه باید حداقل ۳ کاراکتر باشد</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
          <b-col sm="6" md="4">
            <b-form-group label="نام فروشگاه به انگلیسی:">
              <b-form-input
                v-model="$v.step5.website_en_name.$model"
                :state="validateState('website_en_name')"
              ></b-form-input>
              <b-form-invalid-feedback
                v-if="!$v.step5.website_en_name.required"
                id="input-1-live-feedback"
                >نام فروشگاه را وارد کنید</b-form-invalid-feedback
              >
              <b-form-invalid-feedback
                v-else-if="!$v.step5.website_en_name.enchars"
                id="input-1-live-feedback"
                >نام فروشگاه را با حروف انگلیسی وارد
                کنید</b-form-invalid-feedback
              >
              <b-form-invalid-feedback
                v-else-if="!$v.step5.website_en_name.minLength"
                id="input-1-live-feedback"
                >نام فروشگاه باید حداقل ۳ کاراکتر باشد</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
          <b-col sm="6" md="4">
            <b-form-group label="دسته بندی خدمات:">
              <MDDropdown
                id="select_category"
                placeholder="دسته بندی"
                group="9"
                required
                v-model="$v.step5.mdid9_category.$model"
                :state="validateState('mdid9_category')"
              ></MDDropdown>
              <b-form-invalid-feedback
                v-if="!$v.step5.mdid9_category.required"
                id="input-1-live-feedback"
                >لطفا دسته بندی را انتخاب کنید</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
          <b-col sm="6" md="4">
            <b-form-group label="نوع ارز:">
              <MDDropdown
                id="select_curency"
                placeholder="نوع ارز"
                group="12"
                required
                v-model="$v.step5.mdid12_money_type.$model"
                @input="onChange($event)"
              ></MDDropdown>
              <!-- <b-form-invalid-feedback
            v-if="!$v.step5.mdid12_money_type.required"
            id="input-1-live-feedback"
            >لطفا دسته بندی را انتخاب کنید</b-form-invalid-feedback
          > -->
            </b-form-group>
          </b-col>
          <b-col sm="6" md="4" v-if="show_wallet">
            <b-form-group label="انتخاب کیف پول:">
              <b-input-group>
                <template v-slot:append>
                  <b-button variant="success" @click="showAddNewWallet"
                    >جدید</b-button
                  >
                </template>
                <b-form-select
                  placeholder="کیف پول"
                  :options="optionsWallet"
                  v-model="step5.wallet_id"
                ></b-form-select>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col class="col-md-4">
            <b-form-group
              id="shepalink"
              label="آدرس وبسایت:"
              label-for="shepalink-input-1"
            >
              <b-input-group class="mt-3">
                <!-- <template v-slot:append> -->

                <!-- </template> -->
                <b-form-input
                  dir="ltr"
                  v-model="$v.step5.website.$model"
                  :state="validateState('website')"
                ></b-form-input>
                <b-input-group-text>
                  <strong dir="ltr">https://</strong>
                </b-input-group-text>
                <b-form-invalid-feedback
                  v-if="!$v.step5.website.required"
                  id="input-1-live-feedback"
                  >آدرس سایت را وارد کنید</b-form-invalid-feedback
                >
                <b-form-invalid-feedback
                  v-else-if="!$v.step5.website.enchars"
                  id="input-1-live-feedback"
                  >آدرس سایت را با حروف انگلیسی وارد
                  کنید</b-form-invalid-feedback
                >
                <b-form-invalid-feedback
                  v-else-if="!$v.step5.website.minLength"
                  id="input-1-live-feedback"
                  >آدرس سایت باید حداقل ۳ کاراکتر باشد</b-form-invalid-feedback
                >
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col class="col-md-4">
            <b-form-group
              id="shepalink"
              label="شماره شبا واریز وجه:"
              label-for="shepalink-input-1"
            >
              <b-input-group class="mt-3">
                <template v-slot:append>
                  <b-button
                    variant="success"
                    @click="$bvModal.show('addcard-modal')"
                    >جدید</b-button
                  >
                </template>
                <b-form-select
                  :options="userCards"
                  v-model="$v.step5.bankId.$model"
                  :class="$v.step5.bankId.$error ? 'is-invalid' : ''"
                  :state="validateState('bankId')"
                ></b-form-select>
                <b-form-invalid-feedback
                  id="input-1-live-feedback"
                  v-if="!$v.step5.bankId.required"
                  >وارد کردن شماره شبا اجباری است</b-form-invalid-feedback
                >
              </b-input-group>
            </b-form-group>
          </b-col>
        </div>
      </div>
      <div class="form-group">
        <button
          v-if="!showBtn"
          class="btn btn-primary"
          :class="submitted ? 'spinner spinner-light spinner-right' : ''"
        >
          ثبت درخواست درگاه
        </button>
        <router-link
        v-else
         class="btn btn-danger"
         to="/dashbord"
          
        >
          بازگشت به صفحه اصلی
        </router-link>
      </div>
    </form>
    <AddCard v-bind:afterdone="getaccounts"></AddCard>
    <!--end: Wizard Step 5 :state="validateState('address')"-->
    <!-- start modal -->
    <b-modal
      ref="addwallet-modal"
      :title="walletModalTitle"
      style="justify-content: space-around"
      @ok="sendAddOrEditWalletRequest"
      ok-title="ذخیره"
      cancel-title="بازگشت"
    >
      <b-form>
        <b-alert variant="danger" :show="AddEdit_error.length > 0">
          <p v-for="x in AddEdit_error" v-bind:key="x">{{ x }}</p>
        </b-alert>
        <b-form-group
          id="input_wallet_name-group-1"
          label="نام کیف پول: "
          label-for="input_wallet_name-1"
        >
          <b-form-input
            id="input_wallet_name-1"
            required
            v-model="walletName"
            placeholder="عنوان "
          ></b-form-input>
        </b-form-group>
        <b-form-group
          id="mdid12_money_type-group-1"
          label="واحد پولی: "
          label-for="mdid12_money_type-1"
        >
          <MDDropdown
            type="dollar"
            v-bind:group="12"
            v-model="mdid12_money_type1"
          ></MDDropdown>
        </b-form-group>
      </b-form>
    </b-modal>
    <!-- end modal -->
  </b-card>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import persianDate from "../../helpers/persianDate";
import AddCard from "../BankCards/AddCard";
import MDDropdown from "../../components/MDDropdown";
import httpHelper from "../../helpers/httpHelper";
import { GET_WALLETS } from "@/core/services/store/wallets.module";

const enchars = (value, vm) => !/[^A-Za-z\s]/.test(value);
const fachars = (value, vm) => /^[\u0600-\u06FF\s]+$/.test(value);
export default {
  name: "bussinesAndGateway",
  mixins: [validationMixin],
  components: {
    AddCard,
    MDDropdown,
  },
  data() {
    return {
      errorsp: [],
      show_wallet: false,
      userCards: {},
      walletModalTitle: null,
      AddEdit_error: [],
      walletName: null,
      mdid12_money_type1: null,
      submitted: false,
      optionsWallet: [],
      wallet_id: null,
      showBtn: false,
      step5: {
        website: "",
        bankId: "",
        // taxpayercode: "",
        website_name: "",
        website_en_name: "",
        mdid9_category: "",
        mdid12_money_type: 483,
      },
    };
  },
  validations: {
    step5: {
      //   taxpayercode: {},
      bankId: {
        required,
      },
      website_name: {
        fachars,
        required,
        minLength: minLength(3),
      },
      website_en_name: {
        enchars,
        required,
        minLength: minLength(3),
      },
      mdid9_category: { required },
      website: { required },
      mdid12_money_type: { required },
    },
  },
  watch: {
    userCards(neww, old) {
      if (neww.length != 0) {
        this.step5.bankId = neww.at(-1).value;
      }
    },
  },
  computed: {
    loadedWallets() {
      return this.$store.getters.loadedWallets;
    },
  },
  mounted() {
    let api = "wallets";
    this.$store.dispatch(GET_WALLETS, api);
    this.getaccounts();
  },
  methods: {
    onChange(e) {
      if (e == 483) {
        this.show_wallet = false;
        this.optionsWallet = [];
      } else {
        this.show_wallet = true;
        this.createOption(this.loadedWallets);
      }
    },
    createOption(option) {
      option = option.filter((v) => v.md12_title === "دلار");
      this.optionsWallet = [];
      let opt = {};
      option.forEach((element) => {
        Object.assign(opt, { value: element.id, text: element.wallet_name });
        this.optionsWallet.push(opt);
        opt = {};
      });
    },
    getaccounts() {
      //   this.step5.shepalink = this.user.mobile;
      httpHelper.getData("usercards").then((response) => {
        this.userCards = response.result.map((item) => {
          return {
            text: item.shaba_number,
            value: item.id,
          };
        });
      });
    },
    showAddNewWallet: function () {
      this.walletModalTitle = "اضافه کردن کیف پول جدید";
      this.showWalletModal();
    },
    showWalletModal() {
      this.$refs["addwallet-modal"].show();
    },
    sendAddOrEditWalletRequest(event) {
      event.preventDefault();
      if (this.loading) {
        return;
      }
      if (this.walletName == "" || this.walletName == null) {
        this.AddEdit_error.push("نام کیف پول را وارد کنید");
        return;
      }
      this.loading = true;
      httpHelper.setAuth();

      let walletData = {
        wallet_name: this.walletName,
        mdid12_money_type: this.mdid12_money_type1,
      };

      if (this.isInEditMode) walletData.id = this.walletId;

      httpHelper.postData("wallets", walletData).then((response) => {
        if (response.success === true) {
          httpHelper
            .getData("wallets")
            .then((response) => {
              this.createOption(response.result);
              this.hideWalletModal();
              this.loading = false;
            })
            .finally(() => {});
        }
      });
    },
    handleSubmit() {
      this.$v.$touch();
      if (this.$v.step5.$anyError) {
        return;
      }
      this.submitted = true;
      httpHelper
        .postData("userconf/bandp", this.step5)
        .then((res) => {
          if (res.success == true) {
            this.$makeToast("success", "ثبت درخواست درگاه", "ثبت درخواست درگاه با موفقیت انجام شد.", 4000);
            this.showBtn=!this.showBtn;
          } else {
            self.errorsp = [];
            for (var key in res.error) {
              res.error[key].forEach((element) => {
                self.errorsp.push(element);
              });
            }
          }
        })
        .finally(() => {
          this.submitted = false;
        });
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.step5[name];
      return $dirty ? !$error : null;
    },
    hideWalletModal: function () {
      this.$refs["addwallet-modal"].hide();
    },
    // setENChars(field) {
    //   this.$v.step5[field].$model = this.step5[field].toEnDigits();
    // },
  },
};
</script>

<style>
.form-control.is-invalid, .was-validated .form-control:invalid {
  padding-right: calc(1.5em + 1.3rem);
}
.form-control.is-valid, .was-validated .form-control:valid {
  padding-right: calc(1.5em + 1.3rem);
}
.custom-select.is-valid, .was-validated .custom-select:valid{
  padding-right: calc(2em + 1.3rem);
}
</style>